import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
type DesktopPageTransitionProps = {
  /** True while the transition video is covering the page. */
  active: boolean;
  /** Called when the video finishes (or is skipped) so the new page shows. */
  onDone: () => void;
};
const transitionVideo = "https://cdn.magicpatterns.com/uploads/x1j5DpZxozpGwMtt1KsSxB/kling_20261011_VIDEO_Animate_th_768_0.mp4";

/** Plays the ~3 second clip at 1.5× so the transition lasts about 2 seconds. */
const playbackSpeed = 1.5;

/** Longest we'll wait for the video before showing the new page anyway (e.g. if it can't play). */
const maxVideoWaitMs = 15000;

/**
 * Desktop-only transition shown when leaving the home page.
 * The header stays in place; the video plays between the header and footer, and when it
 * ends the new page (already loaded underneath) simply appears.
 */
export function DesktopPageTransition({
  active,
  onDone
}: DesktopPageTransitionProps) {
  const [headerBottom, setHeaderBottom] = useState(0);
  const onDoneRef = useRef(onDone);
  onDoneRef.current = onDone;
  useLayoutEffect(() => {
    if (!active) {
      return;
    }
    const header = document.querySelector("header");
    setHeaderBottom(header ? Math.max(0, header.getBoundingClientRect().bottom) : 0);
  }, [active]);
  useEffect(() => {
    if (!active) {
      return undefined;
    }
    const fallback = window.setTimeout(() => onDoneRef.current(), maxVideoWaitMs);
    return () => window.clearTimeout(fallback);
  }, [active]);
  if (!active) {
    return null;
  }
  return <div className="fixed inset-x-0 bottom-0 z-20 hidden overflow-hidden bg-black md:block" style={{
    top: headerBottom
  }} aria-hidden="true" data-id="element-202" data-mp="2jvoxty9g4k5t">
      <video className="h-full w-full object-cover" src={transitionVideo} autoPlay muted playsInline preload="auto" onLoadedMetadata={event => {
      event.currentTarget.playbackRate = playbackSpeed;
    }} onPlay={event => {
      event.currentTarget.playbackRate = playbackSpeed;
    }} onEnded={() => onDoneRef.current()} onError={() => onDoneRef.current()} data-id="element-203" data-mp="29yu0hiowspt4" />
      <button type="button" tabIndex={-1} onClick={() => onDoneRef.current()} className="absolute bottom-8 right-8 rounded-full border border-white/70 bg-black/45 px-4 py-2 text-xs font-semibold uppercase tracking-[0.16em] text-white opacity-70 transition-opacity duration-150 ease-out hover:opacity-100" data-id="element-204" data-mp="2rhamfwwbsf48">
        Skip
      </button>
    </div>;
}